var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { OmitType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsOptional, IsString } from "class-validator";
import { ConsentDataResourceScope } from "./consentscopes.dtos";
export var SHLLinkStatus;
(function (SHLLinkStatus) {
    SHLLinkStatus["ACTIVE"] = "ACTIVE";
    SHLLinkStatus["USED"] = "USED";
    SHLLinkStatus["REVOKED"] = "REVOKED";
})(SHLLinkStatus || (SHLLinkStatus = {}));
export class BaseSHLDto {
}
__decorate([
    IsString()
], BaseSHLDto.prototype, "id", void 0);
__decorate([
    IsString()
], BaseSHLDto.prototype, "patientId", void 0);
__decorate([
    IsString()
], BaseSHLDto.prototype, "pathSegment", void 0);
__decorate([
    IsString()
], BaseSHLDto.prototype, "label", void 0);
__decorate([
    IsString()
], BaseSHLDto.prototype, "encryptionKey", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], BaseSHLDto.prototype, "expiresAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], BaseSHLDto.prototype, "createdAt", void 0);
__decorate([
    IsBoolean()
], BaseSHLDto.prototype, "isOneTimeUse", void 0);
__decorate([
    IsEnum(ConsentDataResourceScope, { each: true })
], BaseSHLDto.prototype, "consentDataResourceScopes", void 0);
__decorate([
    IsBoolean()
], BaseSHLDto.prototype, "fullRecordWithoutRestrictedData", void 0);
__decorate([
    IsEnum(SHLLinkStatus)
], BaseSHLDto.prototype, "status", void 0);
__decorate([
    IsString()
], BaseSHLDto.prototype, "link", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], BaseSHLDto.prototype, "revokedAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], BaseSHLDto.prototype, "usedAt", void 0);
export class SHLDto extends OmitType(BaseSHLDto, ["pathSegment", "encryptionKey"]) {
}
export class CreateSHLDto extends OmitType(BaseSHLDto, [
    "id",
    "patientId",
    "pathSegment",
    "encryptionKey",
    "expiresAt",
    "createdAt",
    "status",
    "link",
    "revokedAt",
    "usedAt",
]) {
}
export class SHLAccessLogEntryDto {
}
__decorate([
    IsString()
], SHLAccessLogEntryDto.prototype, "id", void 0);
__decorate([
    IsString()
], SHLAccessLogEntryDto.prototype, "shlId", void 0);
__decorate([
    IsString()
], SHLAccessLogEntryDto.prototype, "recipient", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], SHLAccessLogEntryDto.prototype, "accessedAt", void 0);
